import axios from 'axios';

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(null, error => {
    const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;
    const multerSizeError = error.response.data.includes('File too large')  ? true : false;
    const multerFormatError = error.response.data.includes('Accepted file: zip') ? true : false;
    if (!expectedError && !multerFormatError && !multerSizeError) {
        alert('خطا در برقراری ارتباط با سرور')
    }
    else if(multerSizeError){
        alert('حجم فایل زیاد است')
    }
    else if(multerFormatError){
        alert('فرمت فایل باید zip باشد')
    }

    return Promise.reject(error);
});
const http = {
    get: axios.get,
    post: axios.post,
    patch: axios.patch,
    delete: axios.delete
};
export default http;
